import { AppActionTypes } from "../action-types";

const initialState = {
  networkID: null,
};
const networkIDReducer = (state = initialState, action) => {
  switch (action.type) {
    case AppActionTypes.SET_ADMIN_NETWORK_ID:
      return { networkID: action.payload };
    default:
      return state;
  }
};
export default networkIDReducer;
